import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, Checkbox } from "@material-ui/core";
import Button from "../../../components/CustomButtons/Button.jsx";

const OwnersPromptModal = (props) => {
    const { open, close, owners, roleLabel, onConfirm } = props;
    const [selected, setSelected] = useState([]);

    useEffect(() => {
        if (open) setSelected([]);
    }, [open]);

    const toggle = (id) => {
        if (selected.indexOf(id) === -1) setSelected([...selected, id]);
        else setSelected(selected.filter((s) => s !== id));
    };

    const confirm = () => {
        const chosen = (owners || []).filter((o) => selected.indexOf(o.id) !== -1);
        if (typeof onConfirm === "function") onConfirm(chosen);
        close();
    };

    return (
        <Dialog open={!!open} onClose={close} fullWidth maxWidth="sm">
            <DialogTitle>
                <div style={{ textAlign: "center", fontWeight: "bold" }}>Add owner as {roleLabel}?</div>
            </DialogTitle>
            <div style={{ padding: 20 }}>
                <div style={{ marginBottom: 10, fontSize: 13, color: "#555" }}>
                    This property has the following owners. Check which one(s) to add as the {roleLabel}.
                </div>
                <div style={{ maxHeight: 320, overflowY: "auto", border: "1px solid #eee", padding: 8 }}>
                    {(owners || []).map((o) => {
                        const name = `${o.first_name || ''} ${o.last_name || ''}`.trim() || o.email || `Contact #${o.id}`;
                        const company = o.company_name || (o.companies && o.companies[0] && o.companies[0].name) || '';
                        return (
                            <div key={o.id} style={{ display: "flex", alignItems: "center" }}>
                                <Checkbox
                                    checked={selected.indexOf(o.id) !== -1}
                                    onChange={() => toggle(o.id)}
                                />
                                <span>{name}{company ? ` (${company})` : ''}</span>
                            </div>
                        );
                    })}
                    {(!owners || owners.length === 0) && (
                        <div style={{ fontStyle: "italic", color: "#999" }}>No owners on this property.</div>
                    )}
                </div>
                <div style={{ marginTop: 16, display: "flex", gap: 12, justifyContent: "flex-end" }}>
                    <Button color="white" onClick={close}>No, Skip</Button>
                    <Button color="primary" onClick={confirm} disabled={selected.length === 0}>
                        Add Selected as {roleLabel}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

export default OwnersPromptModal;
